<template>
  <div class="bookIndexLink" @click="jumpTo()">
    <span class="book-index-link-chapter-index book-index-chapter-index">
      <slot name="chapterIndex">1 </slot>
    </span>
    <span class="book-index-link-text book-index-text-link">
      <slot name="text"> default page </slot>
    </span>
    <span class="book-index-link-page-index book-index-page-index">
      <slot name="pageIndex"> </slot>
    </span>
  </div>
</template>

<script>
import _ from 'lodash';
export default {
  name: 'tr-book-index-link',
  props: {
    pageId: {
      type: null,
      default: 0,
    },
  },
  data: function () {
    return {};
  },
  mounted: function () {},
  methods: {
    jumpTo() {
      let id = parseInt(this.pageId);
      this.$router.push({
        name: 'page-view',
        params: { id: `${id}`, multibookType: `${this.$store.getters.multibookType}` },
      });
    },
  },
  computed: {
    correctModuleName() {
      const name = `${this.$store.getters.multibookType
        .charAt(0)
        .toUpperCase()}${this.$store.getters.multibookType.slice(1)}`;

      return name;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/sass/variable';
@import '~@/assets/sass/bookIndexVariable';
.bookIndexLink {
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: $bookIndexLinkPadding;
  cursor: pointer;
  .book-index-link-page-index {
    display: flex;
    justify-content: center;
    align-items: flex-end;
  }
  &:hover {
    text-shadow: 0 0 9px $bookIndexChapterColor;
  }
}
</style>
